// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { executeAwaitableHandlerChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, UpdatePrice } from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/ChangeProductQty";
import { ProductModel, ProductPriceDto, RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";

export const XngUpdatePrice: any = async (props: any) => {
    const {
        parameter: { productId, unitOfMeasure, qtyOrdered, product },
    } = props;
    if (product.quoteRequired) {
        return;
    }

    const realTimePricingModel = await executeAwaitableHandlerChain<
        Parameters<typeof loadRealTimePricing>[0],
        RealTimePricingModel
    >(loadRealTimePricing, { productPriceParameters: [{ productId, unitOfMeasure, qtyOrdered }] }, props);
    props.pricing = realTimePricingModel?.realTimePricingResults?.find(o => o.productId === productId);
};

replaceInChain(chain, UpdatePrice, XngUpdatePrice);
